module.exports = __webpack_public_path__ + "static/media/Tile Cotton Trouser.30a2d5b6.jpg";